module.exports = __webpack_public_path__ + "static/media/hitachi.b7d87a35.png";